import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FetchFromServer } from "../api/ServerApi";



const SmartifySignup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    Surname: "",
    Name: "",
    FatherHusband: "",
    Password: "",
    EmailId: "",
    MobileNumber: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSignup = async (e) => {
    e.preventDefault();

    if (
      !formData.Surname ||
      !formData.Name ||
      !formData.FatherHusband ||
      !formData.Password ||
      !formData.EmailId ||
      !formData.MobileNumber
    ) {
      alert("Please fill all fields.");
      return;
    }

    // 1. Send OTP
  const otpData = await FetchFromServer(
  "SendOtpOnWhatsAppbyMobileNumber",
  { MobileNumber: formData.MobileNumber }
);


    if (!Array.isArray(otpData) || otpData.length === 0) {
      alert("Failed to send OTP.");
      return;
    }

    localStorage.setItem("Otp", otpData[0].Otp);
    localStorage.setItem("SignupPayload", JSON.stringify(formData));
    localStorage.setItem("FromSignup", "true");

    alert("OTP sent to your WhatsApp.");
    navigate("/verify-otp");
  };

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <div style={styles.title}>Smartify Sign Up</div>
        <form onSubmit={handleSignup} style={styles.loginBox}>
          <input type="text" name="Surname" placeholder="Surname" value={formData.Surname} onChange={handleChange} style={styles.input} required />
          <input type="text" name="Name" placeholder="Name" value={formData.Name} onChange={handleChange} style={styles.input} required />
          <input type="text" name="FatherHusband" placeholder="Father/Husband Name" value={formData.FatherHusband} onChange={handleChange} style={styles.input} required />
          <input type="text" name="MobileNumber" placeholder="Mobile Number" value={formData.MobileNumber} onChange={handleChange} style={styles.input} required />
          <input type="email" name="EmailId" placeholder="Email ID" value={formData.EmailId} onChange={handleChange} style={styles.input} required />
          <input type="password" name="Password" placeholder="Password" value={formData.Password} onChange={handleChange} style={styles.input} required />

          <button type="submit" style={{ ...styles.button, ...styles.create }}>
            Send OTP
          </button>
          <button type="button" onClick={() => navigate("/")} style={{ ...styles.button, ...styles.login }}>
            Back to Login
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  body: {
    backgroundImage:
      'url("https://wallpapers.com/images/hd/usa-chicago-riverwalk-at-night-1jaq0bwc5dc0g6n0.jpg")',
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
    margin: 0,
    fontFamily: "Helvetica, Arial, sans-serif",
    height: "100vh",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  title: {
    fontSize: "42px",
    color: "white",
    fontWeight: "bold",
    marginBottom: "20px",
  },
  loginBox: {
    background: "rgba(255,255,255,0.1)",
    padding: "20px",
    width: "340px",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    textAlign: "center",
  },
  input: {
    width: "100%",
    padding: "14px",
    margin: "8px 0",
    border: "1px solid #ddd",
    borderRadius: "6px",
    fontSize: "16px",
  },
  button: {
    width: "100%",
    padding: "14px",
    marginTop: "10px",
    fontSize: "16px",
    fontWeight: "bold",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  login: {
    backgroundColor: "#1877f2",
    color: "white",
  },
  create: {
    backgroundColor: "#42b72a",
    color: "white",
  },
};

export default SmartifySignup;
  